import { useDripsyTheme } from 'dripsy';
import Slider from '@react-native-community/slider';
import React from 'react';

export interface UniSliderProps {
  minVal: number;
  maxVal: number;
  value?: number;
  vertical?: boolean;
  disabled?: boolean;
  step?: number;
  onValueChange: (value: number) => void;
}

export const UniSlider: React.FC<UniSliderProps> = ({ minVal, maxVal, value, vertical, disabled, onValueChange, step }) => {
  const { theme } = useDripsyTheme();

  return (
    <Slider
      value={value}
      vertical={vertical}
      minimumValue={minVal}
      maximumValue={maxVal}
      minimumTrackTintColor={theme.colors?.$backgroundInputActive as string}
      maximumTrackTintColor={theme.colors?.$disable as string}
      onValueChange={onValueChange}
      disabled={disabled}
      step={step || 0}
      thumbTintColor="red"
    />
  );
};
